angular.module('iconoglobe').directive('imgPreloader', [function(){
  return {
    restrict: "A",
    link: function(scope, ele, attrs) {
      if(attrs.isslick){
        setTimeout(function(){
          var error = $(ele.context).hasClass('slick-lazyload-error');
          if(error){
            var imageSrc = attrs.lazy;                
            var imageSrcLocal = imageSrc.replace("//iconoglobe.com", "/app/server/php/files");
            var imgLocal = new Image();
            imgLocal.src = imageSrcLocal;
            imgLocal.onload = function(){
              attrs.$set("src", imageSrcLocal);              
            }
            //imgLocal.onerror = function(){
             // ele.hide();
            //  var loader = '<img src="app/images/searching.svg" style="width:80px;display: block;"/>'
            //  ele.after(loader);
           // }   
          }
        },1500);
        
      } else if(attrs.background){
        return;
        var imageSrc = attrs.src;
        var img = new Image();
        img.src = imageSrc;
        img.onload = function(){
          //  do nothing
        }
        img.onerror = function(){
         // console.log("background error")
          if(imageSrc.indexOf("iconoglobe.com") > -1){
            var imageSrcLocal = imageSrc.replace("//iconoglobe.com", "/app/server/php/files");
          } else {
            var imageSrcLocal = imageSrc.replace("/app/server/php/files", "//iconoglobe.com");
          }
          var imgLocal = new Image();
          imgLocal.src = imageSrcLocal;
          imgLocal.onload = function(){
            // ele.css({"backgound-image": "url(" + imageSrcLocal + ")"});
            $(ele).attr('style',"");
          }
         // imgLocal.onerror = function(){
           // ele.hide();
          //  var loader = '<img src="app/images/searching.svg" style="width:80px;display: block;"/>'
          //  ele.after(loader);
          //}
        }
      } else {
       // console.log('here');
        ele.on('error', function(){
          var imageSrc = attrs.src;
          var imageSrcLocal = imageSrc.replace("//iconoglobe.com", "/app/server/php/files");
          var imgLocal = new Image();
          imgLocal.src = imageSrcLocal;
          imgLocal.onload = function(){
            attrs.$set("src", imageSrcLocal);
            if(attrs.promotion){
              angular.element(".promotion-banner").attr("xlink:href", imageSrcLocal);
            }
          }
        //  imgLocal.onerror = function(){
         //  if(attrs.promotion){
           //   attrs.$set("src", "app/images/No_image.svg");
          //    angular.element(".promotion-banner").attr("xlink:href", "app/images/No_image.svg");
         //   } else {
           //   var loader = '<img src="app/images/searching.svg" style="width:80px;display: block;"/>'
           //   ele.after(loader);
          //  }
          //  ele.hide();
        //}
        })
      }
    }
  }
}]);